import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { endEmploymentReasonsStatusSelector } from '../../reducers/employee-selectors';
import { shouldStatusExecute } from '../../reducers/utils/state-manager';

import * as Api from '../../api/api';
import { EmployeeRoutes } from '../../api/routes/api-employee-routes';

export const loadEndEmploymentReasons = () =>
  createGenericDispatcher<Array<EndEmploymentReason>>({
    name: 'LOAD_END_EMPLOYMENT_REASONS',
    args: {},
    loadFunction: () => Api.get(EmployeeRoutes.GET_END_EMPLOYMENT_REASONS),
    shouldExecute: (state) => shouldStatusExecute(endEmploymentReasonsStatusSelector(state)),
  });
